import { createActions, createReducer } from 'reduxsauce'

import ConsultaRemuneracaoADMRHService from '../../servicos/ConsultaRemuneracaoADMRHService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaConsultaCedidosParaMPInicio: [],
    buscaConsultaCedidosParaMPErro: ['erro'],
    buscaConsultaCedidosParaMPSucesso: ['consultaCedidosParaMP'],
    limpar: [],
    setConsultaCedidosParaMPEstadoDT: ['estado'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    dataSincronizacaoDados: null,
    estadoDT: {},
}

// Ação para busca completa
Creators.consultarQuadrosMembros = (filtro, tipoServidor) => {
    return dispatch => {
        dispatch(Creators.buscaConsultaCedidosParaMPInicio())
        let serv = new ConsultaRemuneracaoADMRHService()
        return serv
            .consultarQuadrosMembros(filtro, tipoServidor)
            .then(response => dispatch(Creators.buscaConsultaCedidosParaMPSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaConsultaCedidosParaMPErro(error)))
    }
}

const buscaConsultaCedidosParaMPInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaConsultaCedidosParaMPErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaConsultaCedidosParaMPSucesso = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        lista: action.consultaCedidosParaMP.resultado,
        dataSincronizacaoDados: action.consultaCedidosParaMP.dataSincronizacaoDados,
        carregando: false,
    }
}

const limpar = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const setConsultaCedidosParaMPEstadoDT = (state = INITIAL_STATE, action) => {
    return { ...state, estadoDT: action.estado }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_CONSULTA_CEDIDOS_PARA_MP_INICIO]: buscaConsultaCedidosParaMPInicio,
    [Types.BUSCA_CONSULTA_CEDIDOS_PARA_MP_ERRO]: buscaConsultaCedidosParaMPErro,
    [Types.BUSCA_CONSULTA_CEDIDOS_PARA_MP_SUCESSO]: buscaConsultaCedidosParaMPSucesso,
    [Types.LIMPAR]: limpar,
    [Types.SET_CONSULTA_CEDIDOS_PARA_MP_ESTADO_DT]: setConsultaCedidosParaMPEstadoDT,
})
